module.exports = __webpack_public_path__ + "img/Payangel_Business_main_W.e7ace28f.svg";